import api from './axios';
import { SampleQuestionsResponse } from './types';

interface CompanyInfo {
    // Define fields based on backend's response structure
    [key: string]: any;
}

const qboApi = {
    // Initiate QuickBooks OAuth connection
    initiateQboConnection: async (business_id?: string): Promise<{ auth_url: string }> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.get('/auth/qbo', config);
            return response.data;
        } catch (error) {
            console.error("qboApi.initiateQboConnection failed:", error);
            throw error;
        }
    },

    // Get company info from QBO
    getCompanyInfo: async (business_id?: string): Promise<CompanyInfo> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.get('/qbo/company_info', config);
            return response.data;
        } catch (error) {
            console.error("qboApi.getCompanyInfo failed:", error);
            throw error;
        }
    },

    // Get sample prompts
    getSampleQuestions: async (): Promise<SampleQuestionsResponse> => {
        try {
            const response = await api.get('/qbo/get-prompts');
            return response.data;
        } catch (error) {
            console.error("qboApi.getSampleQuestions failed:", error);
            throw error;
        }
    },
};

export default qboApi;
